export default function convertToSubscript(characters) {
  const characterMap = {
    0: "₀",
    1: "₁",
    2: "₂",
    3: "₃",
    4: "₄",
    5: "₅",
    6: "₆",
    7: "₇",
    8: "₈",
    9: "₉",
    "+": "₊",
    "-": "₋",
    "—": "₋",
    "–": "₋",
    "(": "₍",
    ")": "₎",
    " ": " "
  };
  
  let newString = "";
  
  characters
    .split("")
    .forEach((character) => {
      if (characterMap[character]) {
        newString += characterMap[character];
      }
  });
      
  return newString;
}